import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED
} from "./constants";

export interface IFiatWithdrawalsState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface IFiatWithdrawalsAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: IFiatWithdrawalsState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: IFiatWithdrawalsState, action: IFiatWithdrawalsAction) : IFiatWithdrawalsState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: IFiatWithdrawalsState, action: IFiatWithdrawalsAction) : IFiatWithdrawalsState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: IFiatWithdrawalsState, action: IFiatWithdrawalsAction) : IFiatWithdrawalsState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const reducerMap: { [actionType: string]: (state: IFiatWithdrawalsState, action: IFiatWithdrawalsAction) => IFiatWithdrawalsState } = {
  // Fiat Withdrawals reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_WITHDRAWALS)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_WITHDRAWALS)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_WITHDRAWALS)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const fiatWithdrawalsReducer = (state = INITIAL_STATE, action: IFiatWithdrawalsAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default fiatWithdrawalsReducer;
